// ---------------------------------------------------------------------------
// Test Mode — dataset aggregator (CLE-250).
//
// Re-exports the per-entity builders and wires the cross-entity counts together
// (e.g. client summaries need project + invoice counts) so the whole simulated
// company stays internally consistent.
// ---------------------------------------------------------------------------

import type { ClientSummary } from '../lib/clientsApi';
import type { Person } from '../lib/peopleApi';
import { buildClientSummaries } from './clients';
import { buildPeople } from './people';
import { projectCountsByClient, allocationsByPerson } from './projects';
import { invoiceCountsByClient } from './invoices';

export * from './company';
export * from './companies';
export * from './people';
export * from './clients';
export * from './suppliers';
export * from './subscriptions';
export * from './projects';
export * from './tasks';
export * from './taskStatuses';
export * from './departments';
export * from './taskTemplates';
export * from './meetingNotes';
export * from './leads';
export * from './leadInteractions';
export * from './invoices';
export * from './financials';
export * from './financialReport';
export * from './summaries';
export * from './calendar';
export * from './permissions';
export * from './overdueInvoices';
export * from './emailTemplates';
export * from './employment';
export * from './taskReports';
export * from './settings';
export * from './entityStats';
export * from './teamChat';
export * from './meet';
export * from './reminders';
export * from './leave';
export * from './meetings';

// Client summaries with coherent project + invoice counts.
export function clientSummariesWithCounts(): ClientSummary[] {
  return buildClientSummaries(projectCountsByClient(), invoiceCountsByClient());
}

// People with their project allocations populated (derived from projects).
export function peopleWithAllocations(): Person[] {
  const people = buildPeople();
  const allocByPerson = allocationsByPerson();
  return people.map((p) => ({ ...p, allocations: allocByPerson[p.id] ?? [] }));
}
export * from './bankReconciliation';
